module.exports = __webpack_public_path__ + "static/media/fig_4.6cbd1476.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/rezum/fig_4.png
// module id = 615
// module chunks = 0